import React from 'react'
import Grid from '../../components/molecules/Grid'
import styled from 'styled-components'
import {device, font} from '../../styles/template'
import DesignSystemItem from '../../components/templates/designSystem/DesignSystemItem'
import DesignSystemContent from '../../components/templates/designSystem/DesignSystemContent'

interface Props {}

export const ArticleH1 = styled.h1`
    ${font.mobile.h1};
    @media ${device.tablet} {
      ${font.desktop.h1};
    }
`
export const TestH1 = styled.h1`
    ${font.mobile.h2};
    @media ${device.tablet} {
      ${font.desktop.h2};
    }
`

export const ArticleH2 = styled.h2`
    ${font.mobile.h2};
    @media ${device.tablet} {
      ${font.desktop.h2};
    }
`
export const ArticleH3 = styled.h2`
    ${font.mobile.h3};
    @media ${device.tablet} {
      ${font.desktop.h3};
    }
`
export const ArticleH4 = styled.h4`
    ${font.mobile.h4};
    @media ${device.tablet} {
      ${font.desktop.h4};
    }
`

export const BasicBigText = styled.p`
    ${font.basicBig};
    @media ${device.tablet} {
      ${font.basic};
    }
`

export const BasicText = styled.p`${font.basic};`
export const TextS = styled.span`${font.basicS};`
export const BoldTextS = styled.span`${font.basicBoldS};`
export const TextXS = styled.span`${font.basicXS};`
export const BoldTextXS = styled.span`${font.basicBoldXS};`
export const UpperCaseText = styled.span`${font.upperCase};`

export const AccentTextL = styled.span`${font.accentL};`
export const AccentTextM = styled.span`${font.accentM};`
export const AccentTextS = styled.span`${font.accentS};`

const Fonts: React.FC<Props> = () => {
    return (
        <DesignSystemContent title='Typography'>
            <Grid col='1' gap='2'>
                <ArticleH1>Название статьи <BoldTextXS><code>{'ArticleH1'}</code></BoldTextXS></ArticleH1>

                <TestH1>Название теста <BoldTextXS><code>{'TestH1'}</code></BoldTextXS></TestH1>

                <ArticleH2>Подзаголовок статьи / Headline 2 / Текст вопроса / Залоговок страницы / Название теста <BoldTextXS><code>{'ArticleH2'}</code></BoldTextXS></ArticleH2>

                <ArticleH3>Подзаголовок статьи / Headline 3 <BoldTextXS><code>{'ArticleH3'}</code></BoldTextXS></ArticleH3>


                <ArticleH4>Подзаголовок статьи / Headline 4 <BoldTextXS><code>{'ArticleH4'}</code></BoldTextXS></ArticleH4>

                <BasicBigText>Ответы теста  <BoldTextXS><code>{'BasicBigText'}</code></BoldTextXS></BasicBigText>

                <BasicText>Ваш психологический возраст - 47 лет. Вы - психологически зрелый человек. Прекрасно знаете свои достоинства и недостатки, и при этом умеете ими правильно пользоваться. Вы не делите все на черное и белое, считая, что все вокруг относительно.
                    Это помогает вам чувствовать себя комфортно и уверенно в любой ситуации.<BoldTextXS><code>{'BasicText'}</code></BoldTextXS></BasicText>

                <UpperCaseText>консультация психолога</UpperCaseText>
                <BoldTextXS><code>{'UpperCaseText'}</code></BoldTextXS>

                <TextS>Название теста в карточке(TextS)  <BoldTextXS><code>{'TextS'}</code></BoldTextXS></TextS>

                <BoldTextS>Название карточек в профиле(BoldTextS)  <BoldTextXS><code>{'BoldTextS'}</code></BoldTextXS></BoldTextS>

                <TextXS>Фильтр / Подписи <BoldTextXS><code>{'TextXS'}</code></BoldTextXS></TextXS>

                <BoldTextXS>Категория карточки <BoldTextXS><code>{'BoldTextXS'}</code></BoldTextXS></BoldTextXS>

                <AccentTextL>Карточка в слайдере <BoldTextXS><code>{'AccentTextL'}</code></BoldTextXS></AccentTextL>

                <AccentTextM>Большая кнопка <BoldTextXS><code>{'AccentTextM'}</code></BoldTextXS></AccentTextM>

                <AccentTextS>Пункт меню / Ссылка / Маленькая кнопка <BoldTextXS><code>{'AccentTextS'}</code></BoldTextXS></AccentTextS>
            </Grid>

            <Grid col='1' gap='4'>
                <ArticleH2>Font Family: Blogger Sans</ArticleH2>
                <DesignSystemItem>
                    <AccentTextM>
                        Аа Бб Вв Гг Дд Ее Ёё Жж Зз Ии Йй Кк Лл Мм Нн Оо Пп Рр Сс Тт Уу Фф Хх Цц Чч Шш Щщ Ъъ Ыы Ьь Ээ Юю Яя
                        Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj Kk Ll Mm Nn Oo Pp Qq Rr Ss Tt Uu Vv Ww Xx Yy Zz
                        0123456789 `~!@#$%^&*()-_=+{}[]\|;:’”,.?
                    </AccentTextM>
                </DesignSystemItem>
            </Grid>

            <Grid col='1' gap='4'>
                <ArticleH2>Font Family: Roboto</ArticleH2>
                <DesignSystemItem>
                    <ArticleH4>
                        Аа Бб Вв Гг Дд Ее Ёё Жж Зз Ии Йй Кк Лл Мм Нн Оо Пп Рр Сс Тт Уу Фф Хх Цц Чч Шш Щщ Ъъ Ыы Ьь Ээ Юю Яя
                        Aa Bb Cc Dd Ee Ff Gg Hh Ii Jj Kk Ll Mm Nn Oo Pp Qq Rr Ss Tt Uu Vv Ww Xx Yy Zz
                        0123456789 `~!@#$%^&*()-_=+{}[]\|;:’”,.?
                    </ArticleH4>
                </DesignSystemItem>
            </Grid>
    </DesignSystemContent>
)
}

export default Fonts